<template>
  <svg width="32"
       height="32"
       viewBox="0 0 32 32"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_7585_10686)">
      <path d="M10.9951 9.72705H9.99512V12.3657H10.9951V9.72705Z"
            fill="url(#paint0_radial_7585_10686)"
      />
      <path d="M10.9951 9.72705H9.99512V12.3657H10.9951V9.72705Z"
            fill="url(#paint1_radial_7585_10686)"
      />
      <path d="M21.9951 9.72705H20.9951V12.3657H21.9951V9.72705Z"
            fill="url(#paint2_radial_7585_10686)"
      />
      <path d="M21.9951 9.72705H20.9951V12.3657H21.9951V9.72705Z"
            fill="url(#paint3_radial_7585_10686)"
      />
      <path d="M24.0151 10.01H7.98512C7.44512 10.01 6.99512 9.57 6.99512 9.02V3.99C6.99512 3.45 7.43512 3 7.98512 3H24.0151C24.5551 3 25.0051 3.44 25.0051 3.99V9.02C24.9951 9.57 24.5551 10.01 24.0151 10.01Z"
            fill="url(#paint4_linear_7585_10686)"
      />
      <path d="M24.0151 10.01H7.98512C7.44512 10.01 6.99512 9.57 6.99512 9.02V3.99C6.99512 3.45 7.43512 3 7.98512 3H24.0151C24.5551 3 25.0051 3.44 25.0051 3.99V9.02C24.9951 9.57 24.5551 10.01 24.0151 10.01Z"
            fill="url(#paint5_linear_7585_10686)"
      />
      <path d="M24.0151 10.01H7.98512C7.44512 10.01 6.99512 9.57 6.99512 9.02V3.99C6.99512 3.45 7.43512 3 7.98512 3H24.0151C24.5551 3 25.0051 3.44 25.0051 3.99V9.02C24.9951 9.57 24.5551 10.01 24.0151 10.01Z"
            fill="url(#paint6_linear_7585_10686)"
      />
      <path d="M24.0151 10.01H7.98512C7.44512 10.01 6.99512 9.57 6.99512 9.02V3.99C6.99512 3.45 7.43512 3 7.98512 3H24.0151C24.5551 3 25.0051 3.44 25.0051 3.99V9.02C24.9951 9.57 24.5551 10.01 24.0151 10.01Z"
            fill="url(#paint7_radial_7585_10686)"
      />
      <path d="M12.6649 8.48684C12.6649 8.13684 12.4749 8.00684 12.1249 8.00684H10.7349L11.5449 7.17684C11.8649 6.86684 12.0849 6.57684 12.2249 6.29684C12.3549 6.02684 12.4249 5.74683 12.4249 5.44683C12.4249 4.97683 12.2749 4.62683 11.9749 4.37683C11.6749 4.12683 11.2349 4.00684 10.6749 4.00684C10.4449 4.00684 10.2049 4.03684 9.97494 4.08684C9.74494 4.13684 9.52493 4.22684 9.30493 4.33684C9.13662 4.42099 8.96474 4.62588 9.00493 4.82684C9.02493 4.92684 9.06493 5.01684 9.12493 5.09684C9.24493 5.25684 9.47493 5.32684 9.71493 5.20684C9.85493 5.12684 9.98494 5.07684 10.1149 5.04684C10.2449 5.01684 10.3649 4.99684 10.4749 4.99684C10.9249 4.99684 11.1649 5.23684 11.1649 5.58684C11.1649 5.72684 11.1249 5.86684 11.0449 6.00684C10.9649 6.14684 10.8349 6.31684 10.6549 6.50684L9.41493 7.82684C9.31493 7.92684 9.24493 8.02683 9.18493 8.12683C9.12493 8.22683 9.11494 8.30684 9.11494 8.43684C9.11494 8.62684 9.16493 8.76684 9.25493 8.85684C9.34493 8.95684 9.49493 8.99684 9.69493 8.99684H12.1349C12.5421 8.99684 12.6649 8.78016 12.6649 8.48684Z"
            fill="url(#paint8_linear_7585_10686)"
      />
      <path d="M12.6649 8.48684C12.6649 8.13684 12.4749 8.00684 12.1249 8.00684H10.7349L11.5449 7.17684C11.8649 6.86684 12.0849 6.57684 12.2249 6.29684C12.3549 6.02684 12.4249 5.74683 12.4249 5.44683C12.4249 4.97683 12.2749 4.62683 11.9749 4.37683C11.6749 4.12683 11.2349 4.00684 10.6749 4.00684C10.4449 4.00684 10.2049 4.03684 9.97494 4.08684C9.74494 4.13684 9.52493 4.22684 9.30493 4.33684C9.13662 4.42099 8.96474 4.62588 9.00493 4.82684C9.02493 4.92684 9.06493 5.01684 9.12493 5.09684C9.24493 5.25684 9.47493 5.32684 9.71493 5.20684C9.85493 5.12684 9.98494 5.07684 10.1149 5.04684C10.2449 5.01684 10.3649 4.99684 10.4749 4.99684C10.9249 4.99684 11.1649 5.23684 11.1649 5.58684C11.1649 5.72684 11.1249 5.86684 11.0449 6.00684C10.9649 6.14684 10.8349 6.31684 10.6549 6.50684L9.41493 7.82684C9.31493 7.92684 9.24493 8.02683 9.18493 8.12683C9.12493 8.22683 9.11494 8.30684 9.11494 8.43684C9.11494 8.62684 9.16493 8.76684 9.25493 8.85684C9.34493 8.95684 9.49493 8.99684 9.69493 8.99684H12.1349C12.5421 8.99684 12.6649 8.78016 12.6649 8.48684Z"
            fill="url(#paint9_radial_7585_10686)"
            fill-opacity="0.8"
      />
      <path d="M12.6649 8.48684C12.6649 8.13684 12.4749 8.00684 12.1249 8.00684H10.7349L11.5449 7.17684C11.8649 6.86684 12.0849 6.57684 12.2249 6.29684C12.3549 6.02684 12.4249 5.74683 12.4249 5.44683C12.4249 4.97683 12.2749 4.62683 11.9749 4.37683C11.6749 4.12683 11.2349 4.00684 10.6749 4.00684C10.4449 4.00684 10.2049 4.03684 9.97494 4.08684C9.74494 4.13684 9.52493 4.22684 9.30493 4.33684C9.13662 4.42099 8.96474 4.62588 9.00493 4.82684C9.02493 4.92684 9.06493 5.01684 9.12493 5.09684C9.24493 5.25684 9.47493 5.32684 9.71493 5.20684C9.85493 5.12684 9.98494 5.07684 10.1149 5.04684C10.2449 5.01684 10.3649 4.99684 10.4749 4.99684C10.9249 4.99684 11.1649 5.23684 11.1649 5.58684C11.1649 5.72684 11.1249 5.86684 11.0449 6.00684C10.9649 6.14684 10.8349 6.31684 10.6549 6.50684L9.41493 7.82684C9.31493 7.92684 9.24493 8.02683 9.18493 8.12683C9.12493 8.22683 9.11494 8.30684 9.11494 8.43684C9.11494 8.62684 9.16493 8.76684 9.25493 8.85684C9.34493 8.95684 9.49493 8.99684 9.69493 8.99684H12.1349C12.5421 8.99684 12.6649 8.78016 12.6649 8.48684Z"
            fill="url(#paint10_radial_7585_10686)"
      />
      <path d="M12.6649 8.48684C12.6649 8.13684 12.4749 8.00684 12.1249 8.00684H10.7349L11.5449 7.17684C11.8649 6.86684 12.0849 6.57684 12.2249 6.29684C12.3549 6.02684 12.4249 5.74683 12.4249 5.44683C12.4249 4.97683 12.2749 4.62683 11.9749 4.37683C11.6749 4.12683 11.2349 4.00684 10.6749 4.00684C10.4449 4.00684 10.2049 4.03684 9.97494 4.08684C9.74494 4.13684 9.52493 4.22684 9.30493 4.33684C9.13662 4.42099 8.96474 4.62588 9.00493 4.82684C9.02493 4.92684 9.06493 5.01684 9.12493 5.09684C9.24493 5.25684 9.47493 5.32684 9.71493 5.20684C9.85493 5.12684 9.98494 5.07684 10.1149 5.04684C10.2449 5.01684 10.3649 4.99684 10.4749 4.99684C10.9249 4.99684 11.1649 5.23684 11.1649 5.58684C11.1649 5.72684 11.1249 5.86684 11.0449 6.00684C10.9649 6.14684 10.8349 6.31684 10.6549 6.50684L9.41493 7.82684C9.31493 7.92684 9.24493 8.02683 9.18493 8.12683C9.12493 8.22683 9.11494 8.30684 9.11494 8.43684C9.11494 8.62684 9.16493 8.76684 9.25493 8.85684C9.34493 8.95684 9.49493 8.99684 9.69493 8.99684H12.1349C12.5421 8.99684 12.6649 8.78016 12.6649 8.48684Z"
            fill="url(#paint11_linear_7585_10686)"
            fill-opacity="0.8"
      />
      <path d="M12.6649 8.48684C12.6649 8.13684 12.4749 8.00684 12.1249 8.00684H10.7349L11.5449 7.17684C11.8649 6.86684 12.0849 6.57684 12.2249 6.29684C12.3549 6.02684 12.4249 5.74683 12.4249 5.44683C12.4249 4.97683 12.2749 4.62683 11.9749 4.37683C11.6749 4.12683 11.2349 4.00684 10.6749 4.00684C10.4449 4.00684 10.2049 4.03684 9.97494 4.08684C9.74494 4.13684 9.52493 4.22684 9.30493 4.33684C9.13662 4.42099 8.96474 4.62588 9.00493 4.82684C9.02493 4.92684 9.06493 5.01684 9.12493 5.09684C9.24493 5.25684 9.47493 5.32684 9.71493 5.20684C9.85493 5.12684 9.98494 5.07684 10.1149 5.04684C10.2449 5.01684 10.3649 4.99684 10.4749 4.99684C10.9249 4.99684 11.1649 5.23684 11.1649 5.58684C11.1649 5.72684 11.1249 5.86684 11.0449 6.00684C10.9649 6.14684 10.8349 6.31684 10.6549 6.50684L9.41493 7.82684C9.31493 7.92684 9.24493 8.02683 9.18493 8.12683C9.12493 8.22683 9.11494 8.30684 9.11494 8.43684C9.11494 8.62684 9.16493 8.76684 9.25493 8.85684C9.34493 8.95684 9.49493 8.99684 9.69493 8.99684H12.1349C12.5421 8.99684 12.6649 8.78016 12.6649 8.48684Z"
            fill="url(#paint12_radial_7585_10686)"
      />
      <path d="M12.6649 8.48684C12.6649 8.13684 12.4749 8.00684 12.1249 8.00684H10.7349L11.5449 7.17684C11.8649 6.86684 12.0849 6.57684 12.2249 6.29684C12.3549 6.02684 12.4249 5.74683 12.4249 5.44683C12.4249 4.97683 12.2749 4.62683 11.9749 4.37683C11.6749 4.12683 11.2349 4.00684 10.6749 4.00684C10.4449 4.00684 10.2049 4.03684 9.97494 4.08684C9.74494 4.13684 9.52493 4.22684 9.30493 4.33684C9.13662 4.42099 8.96474 4.62588 9.00493 4.82684C9.02493 4.92684 9.06493 5.01684 9.12493 5.09684C9.24493 5.25684 9.47493 5.32684 9.71493 5.20684C9.85493 5.12684 9.98494 5.07684 10.1149 5.04684C10.2449 5.01684 10.3649 4.99684 10.4749 4.99684C10.9249 4.99684 11.1649 5.23684 11.1649 5.58684C11.1649 5.72684 11.1249 5.86684 11.0449 6.00684C10.9649 6.14684 10.8349 6.31684 10.6549 6.50684L9.41493 7.82684C9.31493 7.92684 9.24493 8.02683 9.18493 8.12683C9.12493 8.22683 9.11494 8.30684 9.11494 8.43684C9.11494 8.62684 9.16493 8.76684 9.25493 8.85684C9.34493 8.95684 9.49493 8.99684 9.69493 8.99684H12.1349C12.5421 8.99684 12.6649 8.78016 12.6649 8.48684Z"
            fill="url(#paint13_radial_7585_10686)"
      />
      <path d="M12.6649 8.48684C12.6649 8.13684 12.4749 8.00684 12.1249 8.00684H10.7349L11.5449 7.17684C11.8649 6.86684 12.0849 6.57684 12.2249 6.29684C12.3549 6.02684 12.4249 5.74683 12.4249 5.44683C12.4249 4.97683 12.2749 4.62683 11.9749 4.37683C11.6749 4.12683 11.2349 4.00684 10.6749 4.00684C10.4449 4.00684 10.2049 4.03684 9.97494 4.08684C9.74494 4.13684 9.52493 4.22684 9.30493 4.33684C9.13662 4.42099 8.96474 4.62588 9.00493 4.82684C9.02493 4.92684 9.06493 5.01684 9.12493 5.09684C9.24493 5.25684 9.47493 5.32684 9.71493 5.20684C9.85493 5.12684 9.98494 5.07684 10.1149 5.04684C10.2449 5.01684 10.3649 4.99684 10.4749 4.99684C10.9249 4.99684 11.1649 5.23684 11.1649 5.58684C11.1649 5.72684 11.1249 5.86684 11.0449 6.00684C10.9649 6.14684 10.8349 6.31684 10.6549 6.50684L9.41493 7.82684C9.31493 7.92684 9.24493 8.02683 9.18493 8.12683C9.12493 8.22683 9.11494 8.30684 9.11494 8.43684C9.11494 8.62684 9.16493 8.76684 9.25493 8.85684C9.34493 8.95684 9.49493 8.99684 9.69493 8.99684H12.1349C12.5421 8.99684 12.6649 8.78016 12.6649 8.48684Z"
            fill="url(#paint14_radial_7585_10686)"
      />
      <path d="M12.6649 8.48684C12.6649 8.13684 12.4749 8.00684 12.1249 8.00684H10.7349L11.5449 7.17684C11.8649 6.86684 12.0849 6.57684 12.2249 6.29684C12.3549 6.02684 12.4249 5.74683 12.4249 5.44683C12.4249 4.97683 12.2749 4.62683 11.9749 4.37683C11.6749 4.12683 11.2349 4.00684 10.6749 4.00684C10.4449 4.00684 10.2049 4.03684 9.97494 4.08684C9.74494 4.13684 9.52493 4.22684 9.30493 4.33684C9.13662 4.42099 8.96474 4.62588 9.00493 4.82684C9.02493 4.92684 9.06493 5.01684 9.12493 5.09684C9.24493 5.25684 9.47493 5.32684 9.71493 5.20684C9.85493 5.12684 9.98494 5.07684 10.1149 5.04684C10.2449 5.01684 10.3649 4.99684 10.4749 4.99684C10.9249 4.99684 11.1649 5.23684 11.1649 5.58684C11.1649 5.72684 11.1249 5.86684 11.0449 6.00684C10.9649 6.14684 10.8349 6.31684 10.6549 6.50684L9.41493 7.82684C9.31493 7.92684 9.24493 8.02683 9.18493 8.12683C9.12493 8.22683 9.11494 8.30684 9.11494 8.43684C9.11494 8.62684 9.16493 8.76684 9.25493 8.85684C9.34493 8.95684 9.49493 8.99684 9.69493 8.99684H12.1349C12.5421 8.99684 12.6649 8.78016 12.6649 8.48684Z"
            fill="url(#paint15_radial_7585_10686)"
      />
      <path d="M17.0049 7.52976C16.9849 7.79976 16.7549 7.99976 16.4849 7.99976H15.9849V8.48977C15.9849 8.75977 15.7849 8.98977 15.5149 9.00977C15.2249 9.02977 14.9849 8.79977 14.9849 8.50977V7.99976H13.4749C13.3849 7.99976 13.3049 7.96976 13.2249 7.92976C13.2149 7.91976 13.2049 7.92977 13.1949 7.91977C13.1849 7.90977 13.1749 7.89976 13.1649 7.88976C13.1349 7.86976 13.1149 7.84976 13.0949 7.81976C13.0749 7.78976 13.0549 7.76977 13.0449 7.73977C13.0349 7.70977 13.0149 7.68976 13.0149 7.64977C13.0049 7.61977 12.9949 7.57976 12.9949 7.54976C12.9949 7.52976 12.9849 7.51976 12.9849 7.49976C12.9849 7.47976 12.9949 7.46976 12.9949 7.45976C12.9949 7.42976 13.0049 7.38976 13.0149 7.35976C13.0249 7.32976 13.0349 7.29976 13.0549 7.26976C13.0649 7.25976 13.0649 7.23976 13.0749 7.22976L15.0849 4.22976C15.0949 4.21976 15.1049 4.20976 15.1149 4.19976C15.1349 4.16976 15.1549 4.14976 15.1849 4.12976C15.2149 4.10976 15.2349 4.08977 15.2649 4.07977C15.2949 4.05977 15.3249 4.04976 15.3549 4.03976C15.3849 4.02976 15.4149 4.01976 15.4549 4.01976C15.4749 4.01976 15.4849 4.00977 15.5049 4.00977C15.5249 4.00977 15.5349 4.01976 15.5549 4.01976C15.5849 4.01976 15.6149 4.02976 15.6449 4.03976C15.6749 4.04976 15.7049 4.05977 15.7349 4.07977C15.7449 4.08977 15.7649 4.08977 15.7749 4.09977C15.7849 4.10977 15.7949 4.11976 15.8049 4.12976C15.8349 4.14976 15.8549 4.16976 15.8749 4.19976C15.8949 4.22976 15.9149 4.24976 15.9249 4.27976C15.9349 4.30976 15.9549 4.32976 15.9549 4.36976C15.9649 4.39976 15.9749 4.43976 15.9749 4.46976C15.9749 4.48976 15.9849 4.49976 15.9849 4.51976V7.01976H16.4949C16.7949 6.99976 17.0249 7.23976 17.0049 7.52976ZM14.9949 6.99976V6.14977L14.4249 6.99976H14.9949Z"
            fill="url(#paint16_linear_7585_10686)"
      />
      <path d="M17.0049 7.52976C16.9849 7.79976 16.7549 7.99976 16.4849 7.99976H15.9849V8.48977C15.9849 8.75977 15.7849 8.98977 15.5149 9.00977C15.2249 9.02977 14.9849 8.79977 14.9849 8.50977V7.99976H13.4749C13.3849 7.99976 13.3049 7.96976 13.2249 7.92976C13.2149 7.91976 13.2049 7.92977 13.1949 7.91977C13.1849 7.90977 13.1749 7.89976 13.1649 7.88976C13.1349 7.86976 13.1149 7.84976 13.0949 7.81976C13.0749 7.78976 13.0549 7.76977 13.0449 7.73977C13.0349 7.70977 13.0149 7.68976 13.0149 7.64977C13.0049 7.61977 12.9949 7.57976 12.9949 7.54976C12.9949 7.52976 12.9849 7.51976 12.9849 7.49976C12.9849 7.47976 12.9949 7.46976 12.9949 7.45976C12.9949 7.42976 13.0049 7.38976 13.0149 7.35976C13.0249 7.32976 13.0349 7.29976 13.0549 7.26976C13.0649 7.25976 13.0649 7.23976 13.0749 7.22976L15.0849 4.22976C15.0949 4.21976 15.1049 4.20976 15.1149 4.19976C15.1349 4.16976 15.1549 4.14976 15.1849 4.12976C15.2149 4.10976 15.2349 4.08977 15.2649 4.07977C15.2949 4.05977 15.3249 4.04976 15.3549 4.03976C15.3849 4.02976 15.4149 4.01976 15.4549 4.01976C15.4749 4.01976 15.4849 4.00977 15.5049 4.00977C15.5249 4.00977 15.5349 4.01976 15.5549 4.01976C15.5849 4.01976 15.6149 4.02976 15.6449 4.03976C15.6749 4.04976 15.7049 4.05977 15.7349 4.07977C15.7449 4.08977 15.7649 4.08977 15.7749 4.09977C15.7849 4.10977 15.7949 4.11976 15.8049 4.12976C15.8349 4.14976 15.8549 4.16976 15.8749 4.19976C15.8949 4.22976 15.9149 4.24976 15.9249 4.27976C15.9349 4.30976 15.9549 4.32976 15.9549 4.36976C15.9649 4.39976 15.9749 4.43976 15.9749 4.46976C15.9749 4.48976 15.9849 4.49976 15.9849 4.51976V7.01976H16.4949C16.7949 6.99976 17.0249 7.23976 17.0049 7.52976ZM14.9949 6.99976V6.14977L14.4249 6.99976H14.9949Z"
            fill="url(#paint17_linear_7585_10686)"
            fill-opacity="0.8"
      />
      <path d="M17.0049 7.52976C16.9849 7.79976 16.7549 7.99976 16.4849 7.99976H15.9849V8.48977C15.9849 8.75977 15.7849 8.98977 15.5149 9.00977C15.2249 9.02977 14.9849 8.79977 14.9849 8.50977V7.99976H13.4749C13.3849 7.99976 13.3049 7.96976 13.2249 7.92976C13.2149 7.91976 13.2049 7.92977 13.1949 7.91977C13.1849 7.90977 13.1749 7.89976 13.1649 7.88976C13.1349 7.86976 13.1149 7.84976 13.0949 7.81976C13.0749 7.78976 13.0549 7.76977 13.0449 7.73977C13.0349 7.70977 13.0149 7.68976 13.0149 7.64977C13.0049 7.61977 12.9949 7.57976 12.9949 7.54976C12.9949 7.52976 12.9849 7.51976 12.9849 7.49976C12.9849 7.47976 12.9949 7.46976 12.9949 7.45976C12.9949 7.42976 13.0049 7.38976 13.0149 7.35976C13.0249 7.32976 13.0349 7.29976 13.0549 7.26976C13.0649 7.25976 13.0649 7.23976 13.0749 7.22976L15.0849 4.22976C15.0949 4.21976 15.1049 4.20976 15.1149 4.19976C15.1349 4.16976 15.1549 4.14976 15.1849 4.12976C15.2149 4.10976 15.2349 4.08977 15.2649 4.07977C15.2949 4.05977 15.3249 4.04976 15.3549 4.03976C15.3849 4.02976 15.4149 4.01976 15.4549 4.01976C15.4749 4.01976 15.4849 4.00977 15.5049 4.00977C15.5249 4.00977 15.5349 4.01976 15.5549 4.01976C15.5849 4.01976 15.6149 4.02976 15.6449 4.03976C15.6749 4.04976 15.7049 4.05977 15.7349 4.07977C15.7449 4.08977 15.7649 4.08977 15.7749 4.09977C15.7849 4.10977 15.7949 4.11976 15.8049 4.12976C15.8349 4.14976 15.8549 4.16976 15.8749 4.19976C15.8949 4.22976 15.9149 4.24976 15.9249 4.27976C15.9349 4.30976 15.9549 4.32976 15.9549 4.36976C15.9649 4.39976 15.9749 4.43976 15.9749 4.46976C15.9749 4.48976 15.9849 4.49976 15.9849 4.51976V7.01976H16.4949C16.7949 6.99976 17.0249 7.23976 17.0049 7.52976ZM14.9949 6.99976V6.14977L14.4249 6.99976H14.9949Z"
            fill="url(#paint18_linear_7585_10686)"
            fill-opacity="0.9"
      />
      <path d="M17.0049 7.52976C16.9849 7.79976 16.7549 7.99976 16.4849 7.99976H15.9849V8.48977C15.9849 8.75977 15.7849 8.98977 15.5149 9.00977C15.2249 9.02977 14.9849 8.79977 14.9849 8.50977V7.99976H13.4749C13.3849 7.99976 13.3049 7.96976 13.2249 7.92976C13.2149 7.91976 13.2049 7.92977 13.1949 7.91977C13.1849 7.90977 13.1749 7.89976 13.1649 7.88976C13.1349 7.86976 13.1149 7.84976 13.0949 7.81976C13.0749 7.78976 13.0549 7.76977 13.0449 7.73977C13.0349 7.70977 13.0149 7.68976 13.0149 7.64977C13.0049 7.61977 12.9949 7.57976 12.9949 7.54976C12.9949 7.52976 12.9849 7.51976 12.9849 7.49976C12.9849 7.47976 12.9949 7.46976 12.9949 7.45976C12.9949 7.42976 13.0049 7.38976 13.0149 7.35976C13.0249 7.32976 13.0349 7.29976 13.0549 7.26976C13.0649 7.25976 13.0649 7.23976 13.0749 7.22976L15.0849 4.22976C15.0949 4.21976 15.1049 4.20976 15.1149 4.19976C15.1349 4.16976 15.1549 4.14976 15.1849 4.12976C15.2149 4.10976 15.2349 4.08977 15.2649 4.07977C15.2949 4.05977 15.3249 4.04976 15.3549 4.03976C15.3849 4.02976 15.4149 4.01976 15.4549 4.01976C15.4749 4.01976 15.4849 4.00977 15.5049 4.00977C15.5249 4.00977 15.5349 4.01976 15.5549 4.01976C15.5849 4.01976 15.6149 4.02976 15.6449 4.03976C15.6749 4.04976 15.7049 4.05977 15.7349 4.07977C15.7449 4.08977 15.7649 4.08977 15.7749 4.09977C15.7849 4.10977 15.7949 4.11976 15.8049 4.12976C15.8349 4.14976 15.8549 4.16976 15.8749 4.19976C15.8949 4.22976 15.9149 4.24976 15.9249 4.27976C15.9349 4.30976 15.9549 4.32976 15.9549 4.36976C15.9649 4.39976 15.9749 4.43976 15.9749 4.46976C15.9749 4.48976 15.9849 4.49976 15.9849 4.51976V7.01976H16.4949C16.7949 6.99976 17.0249 7.23976 17.0049 7.52976ZM14.9949 6.99976V6.14977L14.4249 6.99976H14.9949Z"
            fill="url(#paint19_linear_7585_10686)"
      />
      <path d="M17.0049 7.52976C16.9849 7.79976 16.7549 7.99976 16.4849 7.99976H15.9849V8.48977C15.9849 8.75977 15.7849 8.98977 15.5149 9.00977C15.2249 9.02977 14.9849 8.79977 14.9849 8.50977V7.99976H13.4749C13.3849 7.99976 13.3049 7.96976 13.2249 7.92976C13.2149 7.91976 13.2049 7.92977 13.1949 7.91977C13.1849 7.90977 13.1749 7.89976 13.1649 7.88976C13.1349 7.86976 13.1149 7.84976 13.0949 7.81976C13.0749 7.78976 13.0549 7.76977 13.0449 7.73977C13.0349 7.70977 13.0149 7.68976 13.0149 7.64977C13.0049 7.61977 12.9949 7.57976 12.9949 7.54976C12.9949 7.52976 12.9849 7.51976 12.9849 7.49976C12.9849 7.47976 12.9949 7.46976 12.9949 7.45976C12.9949 7.42976 13.0049 7.38976 13.0149 7.35976C13.0249 7.32976 13.0349 7.29976 13.0549 7.26976C13.0649 7.25976 13.0649 7.23976 13.0749 7.22976L15.0849 4.22976C15.0949 4.21976 15.1049 4.20976 15.1149 4.19976C15.1349 4.16976 15.1549 4.14976 15.1849 4.12976C15.2149 4.10976 15.2349 4.08977 15.2649 4.07977C15.2949 4.05977 15.3249 4.04976 15.3549 4.03976C15.3849 4.02976 15.4149 4.01976 15.4549 4.01976C15.4749 4.01976 15.4849 4.00977 15.5049 4.00977C15.5249 4.00977 15.5349 4.01976 15.5549 4.01976C15.5849 4.01976 15.6149 4.02976 15.6449 4.03976C15.6749 4.04976 15.7049 4.05977 15.7349 4.07977C15.7449 4.08977 15.7649 4.08977 15.7749 4.09977C15.7849 4.10977 15.7949 4.11976 15.8049 4.12976C15.8349 4.14976 15.8549 4.16976 15.8749 4.19976C15.8949 4.22976 15.9149 4.24976 15.9249 4.27976C15.9349 4.30976 15.9549 4.32976 15.9549 4.36976C15.9649 4.39976 15.9749 4.43976 15.9749 4.46976C15.9749 4.48976 15.9849 4.49976 15.9849 4.51976V7.01976H16.4949C16.7949 6.99976 17.0249 7.23976 17.0049 7.52976ZM14.9949 6.99976V6.14977L14.4249 6.99976H14.9949Z"
            fill="url(#paint20_linear_7585_10686)"
      />
      <path d="M17.0049 7.52976C16.9849 7.79976 16.7549 7.99976 16.4849 7.99976H15.9849V8.48977C15.9849 8.75977 15.7849 8.98977 15.5149 9.00977C15.2249 9.02977 14.9849 8.79977 14.9849 8.50977V7.99976H13.4749C13.3849 7.99976 13.3049 7.96976 13.2249 7.92976C13.2149 7.91976 13.2049 7.92977 13.1949 7.91977C13.1849 7.90977 13.1749 7.89976 13.1649 7.88976C13.1349 7.86976 13.1149 7.84976 13.0949 7.81976C13.0749 7.78976 13.0549 7.76977 13.0449 7.73977C13.0349 7.70977 13.0149 7.68976 13.0149 7.64977C13.0049 7.61977 12.9949 7.57976 12.9949 7.54976C12.9949 7.52976 12.9849 7.51976 12.9849 7.49976C12.9849 7.47976 12.9949 7.46976 12.9949 7.45976C12.9949 7.42976 13.0049 7.38976 13.0149 7.35976C13.0249 7.32976 13.0349 7.29976 13.0549 7.26976C13.0649 7.25976 13.0649 7.23976 13.0749 7.22976L15.0849 4.22976C15.0949 4.21976 15.1049 4.20976 15.1149 4.19976C15.1349 4.16976 15.1549 4.14976 15.1849 4.12976C15.2149 4.10976 15.2349 4.08977 15.2649 4.07977C15.2949 4.05977 15.3249 4.04976 15.3549 4.03976C15.3849 4.02976 15.4149 4.01976 15.4549 4.01976C15.4749 4.01976 15.4849 4.00977 15.5049 4.00977C15.5249 4.00977 15.5349 4.01976 15.5549 4.01976C15.5849 4.01976 15.6149 4.02976 15.6449 4.03976C15.6749 4.04976 15.7049 4.05977 15.7349 4.07977C15.7449 4.08977 15.7649 4.08977 15.7749 4.09977C15.7849 4.10977 15.7949 4.11976 15.8049 4.12976C15.8349 4.14976 15.8549 4.16976 15.8749 4.19976C15.8949 4.22976 15.9149 4.24976 15.9249 4.27976C15.9349 4.30976 15.9549 4.32976 15.9549 4.36976C15.9649 4.39976 15.9749 4.43976 15.9749 4.46976C15.9749 4.48976 15.9849 4.49976 15.9849 4.51976V7.01976H16.4949C16.7949 6.99976 17.0249 7.23976 17.0049 7.52976ZM14.9949 6.99976V6.14977L14.4249 6.99976H14.9949Z"
            fill="url(#paint21_radial_7585_10686)"
      />
      <path d="M17.0049 7.52976C16.9849 7.79976 16.7549 7.99976 16.4849 7.99976H15.9849V8.48977C15.9849 8.75977 15.7849 8.98977 15.5149 9.00977C15.2249 9.02977 14.9849 8.79977 14.9849 8.50977V7.99976H13.4749C13.3849 7.99976 13.3049 7.96976 13.2249 7.92976C13.2149 7.91976 13.2049 7.92977 13.1949 7.91977C13.1849 7.90977 13.1749 7.89976 13.1649 7.88976C13.1349 7.86976 13.1149 7.84976 13.0949 7.81976C13.0749 7.78976 13.0549 7.76977 13.0449 7.73977C13.0349 7.70977 13.0149 7.68976 13.0149 7.64977C13.0049 7.61977 12.9949 7.57976 12.9949 7.54976C12.9949 7.52976 12.9849 7.51976 12.9849 7.49976C12.9849 7.47976 12.9949 7.46976 12.9949 7.45976C12.9949 7.42976 13.0049 7.38976 13.0149 7.35976C13.0249 7.32976 13.0349 7.29976 13.0549 7.26976C13.0649 7.25976 13.0649 7.23976 13.0749 7.22976L15.0849 4.22976C15.0949 4.21976 15.1049 4.20976 15.1149 4.19976C15.1349 4.16976 15.1549 4.14976 15.1849 4.12976C15.2149 4.10976 15.2349 4.08977 15.2649 4.07977C15.2949 4.05977 15.3249 4.04976 15.3549 4.03976C15.3849 4.02976 15.4149 4.01976 15.4549 4.01976C15.4749 4.01976 15.4849 4.00977 15.5049 4.00977C15.5249 4.00977 15.5349 4.01976 15.5549 4.01976C15.5849 4.01976 15.6149 4.02976 15.6449 4.03976C15.6749 4.04976 15.7049 4.05977 15.7349 4.07977C15.7449 4.08977 15.7649 4.08977 15.7749 4.09977C15.7849 4.10977 15.7949 4.11976 15.8049 4.12976C15.8349 4.14976 15.8549 4.16976 15.8749 4.19976C15.8949 4.22976 15.9149 4.24976 15.9249 4.27976C15.9349 4.30976 15.9549 4.32976 15.9549 4.36976C15.9649 4.39976 15.9749 4.43976 15.9749 4.46976C15.9749 4.48976 15.9849 4.49976 15.9849 4.51976V7.01976H16.4949C16.7949 6.99976 17.0249 7.23976 17.0049 7.52976ZM14.9949 6.99976V6.14977L14.4249 6.99976H14.9949Z"
            fill="url(#paint22_radial_7585_10686)"
      />
      <path d="M17.0049 7.52976C16.9849 7.79976 16.7549 7.99976 16.4849 7.99976H15.9849V8.48977C15.9849 8.75977 15.7849 8.98977 15.5149 9.00977C15.2249 9.02977 14.9849 8.79977 14.9849 8.50977V7.99976H13.4749C13.3849 7.99976 13.3049 7.96976 13.2249 7.92976C13.2149 7.91976 13.2049 7.92977 13.1949 7.91977C13.1849 7.90977 13.1749 7.89976 13.1649 7.88976C13.1349 7.86976 13.1149 7.84976 13.0949 7.81976C13.0749 7.78976 13.0549 7.76977 13.0449 7.73977C13.0349 7.70977 13.0149 7.68976 13.0149 7.64977C13.0049 7.61977 12.9949 7.57976 12.9949 7.54976C12.9949 7.52976 12.9849 7.51976 12.9849 7.49976C12.9849 7.47976 12.9949 7.46976 12.9949 7.45976C12.9949 7.42976 13.0049 7.38976 13.0149 7.35976C13.0249 7.32976 13.0349 7.29976 13.0549 7.26976C13.0649 7.25976 13.0649 7.23976 13.0749 7.22976L15.0849 4.22976C15.0949 4.21976 15.1049 4.20976 15.1149 4.19976C15.1349 4.16976 15.1549 4.14976 15.1849 4.12976C15.2149 4.10976 15.2349 4.08977 15.2649 4.07977C15.2949 4.05977 15.3249 4.04976 15.3549 4.03976C15.3849 4.02976 15.4149 4.01976 15.4549 4.01976C15.4749 4.01976 15.4849 4.00977 15.5049 4.00977C15.5249 4.00977 15.5349 4.01976 15.5549 4.01976C15.5849 4.01976 15.6149 4.02976 15.6449 4.03976C15.6749 4.04976 15.7049 4.05977 15.7349 4.07977C15.7449 4.08977 15.7649 4.08977 15.7749 4.09977C15.7849 4.10977 15.7949 4.11976 15.8049 4.12976C15.8349 4.14976 15.8549 4.16976 15.8749 4.19976C15.8949 4.22976 15.9149 4.24976 15.9249 4.27976C15.9349 4.30976 15.9549 4.32976 15.9549 4.36976C15.9649 4.39976 15.9749 4.43976 15.9749 4.46976C15.9749 4.48976 15.9849 4.49976 15.9849 4.51976V7.01976H16.4949C16.7949 6.99976 17.0249 7.23976 17.0049 7.52976ZM14.9949 6.99976V6.14977L14.4249 6.99976H14.9949Z"
            fill="url(#paint23_radial_7585_10686)"
      />
      <path d="M17.0049 7.52976C16.9849 7.79976 16.7549 7.99976 16.4849 7.99976H15.9849V8.48977C15.9849 8.75977 15.7849 8.98977 15.5149 9.00977C15.2249 9.02977 14.9849 8.79977 14.9849 8.50977V7.99976H13.4749C13.3849 7.99976 13.3049 7.96976 13.2249 7.92976C13.2149 7.91976 13.2049 7.92977 13.1949 7.91977C13.1849 7.90977 13.1749 7.89976 13.1649 7.88976C13.1349 7.86976 13.1149 7.84976 13.0949 7.81976C13.0749 7.78976 13.0549 7.76977 13.0449 7.73977C13.0349 7.70977 13.0149 7.68976 13.0149 7.64977C13.0049 7.61977 12.9949 7.57976 12.9949 7.54976C12.9949 7.52976 12.9849 7.51976 12.9849 7.49976C12.9849 7.47976 12.9949 7.46976 12.9949 7.45976C12.9949 7.42976 13.0049 7.38976 13.0149 7.35976C13.0249 7.32976 13.0349 7.29976 13.0549 7.26976C13.0649 7.25976 13.0649 7.23976 13.0749 7.22976L15.0849 4.22976C15.0949 4.21976 15.1049 4.20976 15.1149 4.19976C15.1349 4.16976 15.1549 4.14976 15.1849 4.12976C15.2149 4.10976 15.2349 4.08977 15.2649 4.07977C15.2949 4.05977 15.3249 4.04976 15.3549 4.03976C15.3849 4.02976 15.4149 4.01976 15.4549 4.01976C15.4749 4.01976 15.4849 4.00977 15.5049 4.00977C15.5249 4.00977 15.5349 4.01976 15.5549 4.01976C15.5849 4.01976 15.6149 4.02976 15.6449 4.03976C15.6749 4.04976 15.7049 4.05977 15.7349 4.07977C15.7449 4.08977 15.7649 4.08977 15.7749 4.09977C15.7849 4.10977 15.7949 4.11976 15.8049 4.12976C15.8349 4.14976 15.8549 4.16976 15.8749 4.19976C15.8949 4.22976 15.9149 4.24976 15.9249 4.27976C15.9349 4.30976 15.9549 4.32976 15.9549 4.36976C15.9649 4.39976 15.9749 4.43976 15.9749 4.46976C15.9749 4.48976 15.9849 4.49976 15.9849 4.51976V7.01976H16.4949C16.7949 6.99976 17.0249 7.23976 17.0049 7.52976ZM14.9949 6.99976V6.14977L14.4249 6.99976H14.9949Z"
            fill="url(#paint24_radial_7585_10686)"
      />
      <path d="M22.9951 4.49976V8.51976C22.9951 8.78976 22.7751 9.00977 22.5051 9.00977H22.4851C22.2151 9.00977 21.9951 8.78976 21.9951 8.51976V7.01976H19.9951V8.51976C19.9951 8.78976 19.7751 9.00977 19.5051 9.00977H19.4851C19.2151 9.00977 18.9951 8.78976 18.9951 8.51976V4.49976C18.9951 4.22976 19.2151 4.00977 19.4851 4.00977H19.5051C19.7751 4.00977 19.9951 4.22976 19.9951 4.49976V6.00977H21.9951V4.49976C21.9951 4.22976 22.2151 4.00977 22.4851 4.00977H22.5051C22.7751 4.00977 22.9951 4.22976 22.9951 4.49976Z"
            fill="url(#paint25_linear_7585_10686)"
      />
      <path d="M22.9951 4.49976V8.51976C22.9951 8.78976 22.7751 9.00977 22.5051 9.00977H22.4851C22.2151 9.00977 21.9951 8.78976 21.9951 8.51976V7.01976H19.9951V8.51976C19.9951 8.78976 19.7751 9.00977 19.5051 9.00977H19.4851C19.2151 9.00977 18.9951 8.78976 18.9951 8.51976V4.49976C18.9951 4.22976 19.2151 4.00977 19.4851 4.00977H19.5051C19.7751 4.00977 19.9951 4.22976 19.9951 4.49976V6.00977H21.9951V4.49976C21.9951 4.22976 22.2151 4.00977 22.4851 4.00977H22.5051C22.7751 4.00977 22.9951 4.22976 22.9951 4.49976Z"
            fill="url(#paint26_linear_7585_10686)"
      />
      <path d="M22.9951 4.49976V8.51976C22.9951 8.78976 22.7751 9.00977 22.5051 9.00977H22.4851C22.2151 9.00977 21.9951 8.78976 21.9951 8.51976V7.01976H19.9951V8.51976C19.9951 8.78976 19.7751 9.00977 19.5051 9.00977H19.4851C19.2151 9.00977 18.9951 8.78976 18.9951 8.51976V4.49976C18.9951 4.22976 19.2151 4.00977 19.4851 4.00977H19.5051C19.7751 4.00977 19.9951 4.22976 19.9951 4.49976V6.00977H21.9951V4.49976C21.9951 4.22976 22.2151 4.00977 22.4851 4.00977H22.5051C22.7751 4.00977 22.9951 4.22976 22.9951 4.49976Z"
            fill="url(#paint27_linear_7585_10686)"
      />
      <path d="M22.9951 4.49976V8.51976C22.9951 8.78976 22.7751 9.00977 22.5051 9.00977H22.4851C22.2151 9.00977 21.9951 8.78976 21.9951 8.51976V7.01976H19.9951V8.51976C19.9951 8.78976 19.7751 9.00977 19.5051 9.00977H19.4851C19.2151 9.00977 18.9951 8.78976 18.9951 8.51976V4.49976C18.9951 4.22976 19.2151 4.00977 19.4851 4.00977H19.5051C19.7751 4.00977 19.9951 4.22976 19.9951 4.49976V6.00977H21.9951V4.49976C21.9951 4.22976 22.2151 4.00977 22.4851 4.00977H22.5051C22.7751 4.00977 22.9951 4.22976 22.9951 4.49976Z"
            fill="url(#paint28_linear_7585_10686)"
            fill-opacity="0.4"
      />
      <path d="M22.9951 4.49976V8.51976C22.9951 8.78976 22.7751 9.00977 22.5051 9.00977H22.4851C22.2151 9.00977 21.9951 8.78976 21.9951 8.51976V7.01976H19.9951V8.51976C19.9951 8.78976 19.7751 9.00977 19.5051 9.00977H19.4851C19.2151 9.00977 18.9951 8.78976 18.9951 8.51976V4.49976C18.9951 4.22976 19.2151 4.00977 19.4851 4.00977H19.5051C19.7751 4.00977 19.9951 4.22976 19.9951 4.49976V6.00977H21.9951V4.49976C21.9951 4.22976 22.2151 4.00977 22.4851 4.00977H22.5051C22.7751 4.00977 22.9951 4.22976 22.9951 4.49976Z"
            fill="url(#paint29_linear_7585_10686)"
      />
      <path d="M22.9951 4.49976V8.51976C22.9951 8.78976 22.7751 9.00977 22.5051 9.00977H22.4851C22.2151 9.00977 21.9951 8.78976 21.9951 8.51976V7.01976H19.9951V8.51976C19.9951 8.78976 19.7751 9.00977 19.5051 9.00977H19.4851C19.2151 9.00977 18.9951 8.78976 18.9951 8.51976V4.49976C18.9951 4.22976 19.2151 4.00977 19.4851 4.00977H19.5051C19.7751 4.00977 19.9951 4.22976 19.9951 4.49976V6.00977H21.9951V4.49976C21.9951 4.22976 22.2151 4.00977 22.4851 4.00977H22.5051C22.7751 4.00977 22.9951 4.22976 22.9951 4.49976Z"
            fill="url(#paint30_radial_7585_10686)"
      />
      <path d="M22.9951 4.49976V8.51976C22.9951 8.78976 22.7751 9.00977 22.5051 9.00977H22.4851C22.2151 9.00977 21.9951 8.78976 21.9951 8.51976V7.01976H19.9951V8.51976C19.9951 8.78976 19.7751 9.00977 19.5051 9.00977H19.4851C19.2151 9.00977 18.9951 8.78976 18.9951 8.51976V4.49976C18.9951 4.22976 19.2151 4.00977 19.4851 4.00977H19.5051C19.7751 4.00977 19.9951 4.22976 19.9951 4.49976V6.00977H21.9951V4.49976C21.9951 4.22976 22.2151 4.00977 22.4851 4.00977H22.5051C22.7751 4.00977 22.9951 4.22976 22.9951 4.49976Z"
            fill="url(#paint31_radial_7585_10686)"
      />
      <path d="M22.9951 4.49976V8.51976C22.9951 8.78976 22.7751 9.00977 22.5051 9.00977H22.4851C22.2151 9.00977 21.9951 8.78976 21.9951 8.51976V7.01976H19.9951V8.51976C19.9951 8.78976 19.7751 9.00977 19.5051 9.00977H19.4851C19.2151 9.00977 18.9951 8.78976 18.9951 8.51976V4.49976C18.9951 4.22976 19.2151 4.00977 19.4851 4.00977H19.5051C19.7751 4.00977 19.9951 4.22976 19.9951 4.49976V6.00977H21.9951V4.49976C21.9951 4.22976 22.2151 4.00977 22.4851 4.00977H22.5051C22.7751 4.00977 22.9951 4.22976 22.9951 4.49976Z"
            fill="url(#paint32_radial_7585_10686)"
      />
      <path d="M22.9951 4.49976V8.51976C22.9951 8.78976 22.7751 9.00977 22.5051 9.00977H22.4851C22.2151 9.00977 21.9951 8.78976 21.9951 8.51976V7.01976H19.9951V8.51976C19.9951 8.78976 19.7751 9.00977 19.5051 9.00977H19.4851C19.2151 9.00977 18.9951 8.78976 18.9951 8.51976V4.49976C18.9951 4.22976 19.2151 4.00977 19.4851 4.00977H19.5051C19.7751 4.00977 19.9951 4.22976 19.9951 4.49976V6.00977H21.9951V4.49976C21.9951 4.22976 22.2151 4.00977 22.4851 4.00977H22.5051C22.7751 4.00977 22.9951 4.22976 22.9951 4.49976Z"
            fill="url(#paint33_radial_7585_10686)"
      />
      <path d="M28.9951 15.1201H2.99512V28.01H28.9951V15.1201Z"
            fill="url(#paint34_linear_7585_10686)"
      />
      <path d="M28.9951 15.1201H2.99512V28.01H28.9951V15.1201Z"
            fill="url(#paint35_linear_7585_10686)"
      />
      <path d="M28.9951 15.1201H2.99512V28.01H28.9951V15.1201Z"
            fill="url(#paint36_radial_7585_10686)"
      />
      <path d="M28.9951 15.1201H2.99512V28.01H28.9951V15.1201Z"
            fill="url(#paint37_linear_7585_10686)"
      />
      <path d="M28.9951 15.1201H2.99512V28.01H28.9951V15.1201Z"
            fill="url(#paint38_radial_7585_10686)"
            fill-opacity="0.8"
      />
      <path d="M28.9951 15.1201H2.99512V28.01H28.9951V15.1201Z"
            fill="url(#paint39_linear_7585_10686)"
      />
      <path d="M13.9951 28.0098H4.99512V18.5998C4.99512 18.2698 5.25512 18.0098 5.58512 18.0098H13.4051C13.7351 18.0098 13.9951 18.2698 13.9951 18.5998V28.0098Z"
            fill="url(#paint40_linear_7585_10686)"
      />
      <path d="M13.9951 28.0098H4.99512V18.5998C4.99512 18.2698 5.25512 18.0098 5.58512 18.0098H13.4051C13.7351 18.0098 13.9951 18.2698 13.9951 18.5998V28.0098Z"
            fill="url(#paint41_linear_7585_10686)"
            fill-opacity="0.6"
      />
      <path d="M13.9951 28.0098H4.99512V18.5998C4.99512 18.2698 5.25512 18.0098 5.58512 18.0098H13.4051C13.7351 18.0098 13.9951 18.2698 13.9951 18.5998V28.0098Z"
            fill="url(#paint42_linear_7585_10686)"
            fill-opacity="0.6"
      />
      <path d="M13.9951 28.0098H4.99512V18.5998C4.99512 18.2698 5.25512 18.0098 5.58512 18.0098H13.4051C13.7351 18.0098 13.9951 18.2698 13.9951 18.5998V28.0098Z"
            fill="url(#paint43_linear_7585_10686)"
      />
      <path d="M13.9951 28.0098H4.99512V18.5998C4.99512 18.2698 5.25512 18.0098 5.58512 18.0098H13.4051C13.7351 18.0098 13.9951 18.2698 13.9951 18.5998V28.0098Z"
            fill="url(#paint44_linear_7585_10686)"
      />
      <path d="M13.9951 28.0098H4.99512V18.5998C4.99512 18.2698 5.25512 18.0098 5.58512 18.0098H13.4051C13.7351 18.0098 13.9951 18.2698 13.9951 18.5998V28.0098Z"
            fill="url(#paint45_radial_7585_10686)"
      />
      <path d="M25.5151 24.01H17.4851C17.2151 24.01 16.9951 23.79 16.9951 23.52V20.49C16.9951 20.22 17.2151 20 17.4851 20H25.5151C25.7851 20 26.0051 20.22 26.0051 20.49V23.52C25.9951 23.79 25.7751 24.01 25.5151 24.01Z"
            fill="#5EE6FF"
      />
      <path d="M25.5151 24.01H17.4851C17.2151 24.01 16.9951 23.79 16.9951 23.52V20.49C16.9951 20.22 17.2151 20 17.4851 20H25.5151C25.7851 20 26.0051 20.22 26.0051 20.49V23.52C25.9951 23.79 25.7751 24.01 25.5151 24.01Z"
            fill="url(#paint46_linear_7585_10686)"
      />
      <path d="M25.5151 24.01H17.4851C17.2151 24.01 16.9951 23.79 16.9951 23.52V20.49C16.9951 20.22 17.2151 20 17.4851 20H25.5151C25.7851 20 26.0051 20.22 26.0051 20.49V23.52C25.9951 23.79 25.7751 24.01 25.5151 24.01Z"
            fill="url(#paint47_linear_7585_10686)"
      />
      <path d="M25.5151 24.01H17.4851C17.2151 24.01 16.9951 23.79 16.9951 23.52V20.49C16.9951 20.22 17.2151 20 17.4851 20H25.5151C25.7851 20 26.0051 20.22 26.0051 20.49V23.52C25.9951 23.79 25.7751 24.01 25.5151 24.01Z"
            fill="url(#paint48_linear_7585_10686)"
      />
      <path d="M25.5151 24.01H17.4851C17.2151 24.01 16.9951 23.79 16.9951 23.52V20.49C16.9951 20.22 17.2151 20 17.4851 20H25.5151C25.7851 20 26.0051 20.22 26.0051 20.49V23.52C25.9951 23.79 25.7751 24.01 25.5151 24.01Z"
            fill="url(#paint49_linear_7585_10686)"
      />
      <path d="M25.5151 24.01H17.4851C17.2151 24.01 16.9951 23.79 16.9951 23.52V20.49C16.9951 20.22 17.2151 20 17.4851 20H25.5151C25.7851 20 26.0051 20.22 26.0051 20.49V23.52C25.9951 23.79 25.7751 24.01 25.5151 24.01Z"
            fill="url(#paint50_linear_7585_10686)"
      />
      <path d="M25.5151 24.01H17.4851C17.2151 24.01 16.9951 23.79 16.9951 23.52V20.49C16.9951 20.22 17.2151 20 17.4851 20H25.5151C25.7851 20 26.0051 20.22 26.0051 20.49V23.52C25.9951 23.79 25.7751 24.01 25.5151 24.01Z"
            fill="url(#paint51_linear_7585_10686)"
      />
      <path d="M29.2351 16.01H2.76511C2.34511 16.01 1.99512 15.67 1.99512 15.24V12.77C1.99512 12.35 2.33511 12 2.76511 12H29.2351C29.6551 12 30.0051 12.34 30.0051 12.77V15.24C29.9951 15.67 29.6551 16.01 29.2351 16.01Z"
            fill="url(#paint52_linear_7585_10686)"
      />
      <path d="M29.2351 16.01H2.76511C2.34511 16.01 1.99512 15.67 1.99512 15.24V12.77C1.99512 12.35 2.33511 12 2.76511 12H29.2351C29.6551 12 30.0051 12.34 30.0051 12.77V15.24C29.9951 15.67 29.6551 16.01 29.2351 16.01Z"
            fill="url(#paint53_linear_7585_10686)"
      />
      <path d="M29.2351 16.01H2.76511C2.34511 16.01 1.99512 15.67 1.99512 15.24V12.77C1.99512 12.35 2.33511 12 2.76511 12H29.2351C29.6551 12 30.0051 12.34 30.0051 12.77V15.24C29.9951 15.67 29.6551 16.01 29.2351 16.01Z"
            fill="url(#paint54_linear_7585_10686)"
      />
      <path d="M29.2351 16.01H2.76511C2.34511 16.01 1.99512 15.67 1.99512 15.24V12.77C1.99512 12.35 2.33511 12 2.76511 12H29.2351C29.6551 12 30.0051 12.34 30.0051 12.77V15.24C29.9951 15.67 29.6551 16.01 29.2351 16.01Z"
            fill="url(#paint55_linear_7585_10686)"
      />
      <path d="M29.2351 16.01H2.76511C2.34511 16.01 1.99512 15.67 1.99512 15.24V12.77C1.99512 12.35 2.33511 12 2.76511 12H29.2351C29.6551 12 30.0051 12.34 30.0051 12.77V15.24C29.9951 15.67 29.6551 16.01 29.2351 16.01Z"
            fill="url(#paint56_linear_7585_10686)"
      />
      <rect x="5.96875"
            y="18.9873"
            width="3.01716"
            height="7.97389"
            rx="0.35"
            fill="url(#paint57_linear_7585_10686)"
      />
      <rect x="5.96875"
            y="18.9873"
            width="3.01716"
            height="7.97389"
            rx="0.35"
            fill="url(#paint58_linear_7585_10686)"
      />
      <rect x="5.96875"
            y="18.9873"
            width="3.01716"
            height="7.97389"
            rx="0.35"
            fill="url(#paint59_linear_7585_10686)"
      />
      <rect x="5.96875"
            y="18.9873"
            width="3.01716"
            height="7.97389"
            rx="0.35"
            fill="url(#paint60_linear_7585_10686)"
      />
      <rect x="5.96875"
            y="18.9873"
            width="3.01716"
            height="7.97389"
            rx="0.35"
            fill="url(#paint61_linear_7585_10686)"
      />
      <rect x="5.96875"
            y="18.9873"
            width="3.01716"
            height="7.97389"
            rx="0.35"
            fill="url(#paint62_linear_7585_10686)"
      />
      <rect x="5.96875"
            y="18.9873"
            width="3.01716"
            height="7.97389"
            rx="0.35"
            fill="url(#paint63_linear_7585_10686)"
      />
      <rect x="10.0039"
            y="18.9873"
            width="3.01716"
            height="7.97389"
            rx="0.35"
            fill="url(#paint64_linear_7585_10686)"
      />
      <rect x="10.0039"
            y="18.9873"
            width="3.01716"
            height="7.97389"
            rx="0.35"
            fill="url(#paint65_linear_7585_10686)"
      />
      <rect x="10.0039"
            y="18.9873"
            width="3.01716"
            height="7.97389"
            rx="0.35"
            fill="url(#paint66_linear_7585_10686)"
      />
      <rect x="10.0039"
            y="18.9873"
            width="3.01716"
            height="7.97389"
            rx="0.35"
            fill="url(#paint67_linear_7585_10686)"
      />
      <rect x="10.0039"
            y="18.9873"
            width="3.01716"
            height="7.97389"
            rx="0.35"
            fill="url(#paint68_linear_7585_10686)"
      />
      <rect x="10.0039"
            y="18.9873"
            width="3.01716"
            height="7.97389"
            rx="0.35"
            fill="url(#paint69_linear_7585_10686)"
      />
      <rect x="10.0039"
            y="18.9873"
            width="3.01716"
            height="7.97389"
            rx="0.35"
            fill="url(#paint70_linear_7585_10686)"
      />
    </g>
    <defs>
      <radialGradient id="paint0_radial_7585_10686"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(10.922 12.3657) rotate(180) scale(1.23759 3.98298)"
      >
        <stop stop-color="#7A5E81" />
        <stop offset="1"
              stop-color="#281D26"
        />
      </radialGradient>
      <radialGradient id="paint1_radial_7585_10686"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(11.152 12.3657) rotate(180) scale(0.656933 2.15917)"
      >
        <stop stop-color="#836488" />
        <stop offset="1"
              stop-color="#836488"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint2_radial_7585_10686"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(21.922 12.3657) rotate(180) scale(1.23759 3.98298)"
      >
        <stop stop-color="#7A5E81" />
        <stop offset="1"
              stop-color="#281D26"
        />
      </radialGradient>
      <radialGradient id="paint3_radial_7585_10686"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(22.152 12.3657) rotate(180) scale(0.656933 2.15917)"
      >
        <stop stop-color="#836488" />
        <stop offset="1"
              stop-color="#836488"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint4_linear_7585_10686"
                      x1="9.56417"
                      y1="8.09728"
                      x2="24.554"
                      y2="8.09728"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A59EAA" />
        <stop offset="1"
              stop-color="#BDB5C2"
        />
      </linearGradient>
      <linearGradient id="paint5_linear_7585_10686"
                      x1="14.9066"
                      y1="10.6828"
                      x2="14.8776"
                      y2="2.52477"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0396643"
              stop-color="#846C7C"
        />
        <stop offset="0.14472"
              stop-color="#ADA5B2"
        />
        <stop offset="0.223903"
              stop-color="#AEA6B3"
              stop-opacity="0"
        />
        <stop offset="0.840316"
              stop-color="#BBB3C0"
              stop-opacity="0"
        />
        <stop offset="0.901222"
              stop-color="#B7AFBC"
        />
        <stop offset="0.962649"
              stop-color="#BDB5C2"
        />
      </linearGradient>
      <linearGradient id="paint6_linear_7585_10686"
                      x1="6.42748"
                      y1="6.505"
                      x2="25.4964"
                      y2="6.505"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0199671"
              stop-color="#846C7C"
        />
        <stop offset="0.0659072"
              stop-color="#A199A7"
        />
        <stop offset="0.10544"
              stop-color="#AEA6B3"
              stop-opacity="0"
        />
        <stop offset="0.882694"
              stop-color="#BBB3C0"
              stop-opacity="0"
        />
        <stop offset="0.938478"
              stop-color="#B7AFBC"
        />
        <stop offset="0.971645"
              stop-color="#D2CCD5"
        />
      </linearGradient>
      <radialGradient id="paint7_radial_7585_10686"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(7.57139 9.68181) rotate(131.629) scale(1.14726 2.38007)"
      >
        <stop stop-color="#948292" />
        <stop offset="0.381655"
              stop-color="#978695"
              stop-opacity="0.61"
        />
        <stop offset="0.998642"
              stop-color="#A8A1AD"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint8_linear_7585_10686"
                      x1="10.8311"
                      y1="4.00684"
                      x2="10.8311"
                      y2="9.00359"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5D235A" />
        <stop offset="1"
              stop-color="#222058"
        />
      </linearGradient>
      <radialGradient id="paint9_radial_7585_10686"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(10.4357 5.67435) rotate(70.3197) scale(2.58209 3.38229)"
      >
        <stop offset="0.19781"
              stop-color="#19171A"
        />
        <stop offset="0.259293"
              stop-color="#3F2245"
              stop-opacity="0"
        />
        <stop offset="0.471999"
              stop-color="#643566"
              stop-opacity="0.93"
        />
        <stop offset="0.780916"
              stop-color="#422255"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint10_radial_7585_10686"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(10.7529 5.55158) rotate(154.662) scale(1.04364 1.01927)"
      >
        <stop offset="0.277712"
              stop-color="#201A28"
        />
        <stop offset="0.569781"
              stop-color="#321F45"
              stop-opacity="0.85"
        />
        <stop offset="0.907282"
              stop-color="#3B2253"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint11_linear_7585_10686"
                      x1="11.5854"
                      y1="9.855"
                      x2="11.5892"
                      y2="7.77192"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.431099"
              stop-color="#0A0220"
              stop-opacity="0.88"
        />
        <stop offset="0.564131"
              stop-color="#32235A"
              stop-opacity="0.4"
        />
        <stop offset="0.723458"
              stop-color="#F0EFFF"
              stop-opacity="0.1"
        />
        <stop offset="0.949513"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint12_radial_7585_10686"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-0.83117 0.177134 -0.268292 -1.76669 9.17993 4.82418)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#36223C" />
        <stop offset="1"
              stop-color="#312652"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint13_radial_7585_10686"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-0.972455 0.284053 -0.475119 -2.07656 9.4835 8.42524)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#29223E" />
        <stop offset="0.773637"
              stop-color="#32223E"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint14_radial_7585_10686"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientTransform="matrix(-1.49576 -0.00364218 0.193928 -3.13916 12.6649 8.47348)"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.122721"
              stop-color="#1C0C4B"
        />
        <stop offset="0.471999"
              stop-color="#32223E"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint15_radial_7585_10686"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(10.6629 6.99499) rotate(-119.04) scale(1.0166 2.31892)"
      >
        <stop stop-color="#3A2259" />
        <stop offset="0.204627"
              stop-color="#3A2259"
        />
        <stop offset="1"
              stop-color="#3B2253"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint16_linear_7585_10686"
                      x1="14.9945"
                      y1="4.00977"
                      x2="14.9945"
                      y2="9.01775"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5D235A" />
        <stop offset="1"
              stop-color="#222058"
        />
      </linearGradient>
      <linearGradient id="paint17_linear_7585_10686"
                      x1="13.5353"
                      y1="4.90543"
                      x2="15.7852"
                      y2="6.36893"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.216941"
              stop-color="#452259"
              stop-opacity="0"
        />
        <stop offset="0.52515"
              stop-color="#FFFFFF"
              stop-opacity="0.1"
        />
        <stop offset="1"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint18_linear_7585_10686"
                      x1="15.8219"
                      y1="9.13261"
                      x2="15.8219"
                      y2="6.01668"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#32235A"
              stop-opacity="0"
        />
        <stop offset="0.366408"
              stop-color="#32235A"
              stop-opacity="0"
        />
        <stop offset="0.517857"
              stop-color="#F0EFFF"
              stop-opacity="0.12"
        />
        <stop offset="0.949513"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint19_linear_7585_10686"
                      x1="13.3173"
                      y1="6.33372"
                      x2="16.3029"
                      y2="6.31584"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.509322"
              stop-color="#32235A"
              stop-opacity="0"
        />
        <stop offset="0.73668"
              stop-color="#7886FF"
              stop-opacity="0.1"
        />
        <stop offset="0.898781"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint20_linear_7585_10686"
                      x1="13.5353"
                      y1="4.90543"
                      x2="15.7852"
                      y2="6.36893"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.334698"
              stop-color="#3B224A"
        />
        <stop offset="0.470822"
              stop-color="#462459"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint21_radial_7585_10686"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(15.6096 4.00977) rotate(-69.4852) scale(1.21352 2.73125)"
      >
        <stop stop-color="#432347" />
        <stop offset="0.74792"
              stop-color="#312652"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint22_radial_7585_10686"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(15.2649 8.64801) rotate(114.779) scale(1.41697 4.58188)"
      >
        <stop stop-color="#1A132D" />
        <stop offset="0.520164"
              stop-color="#312652"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint23_radial_7585_10686"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(13.1269 7.60153) rotate(174.958) scale(1.71863 3.03183)"
      >
        <stop offset="0.0929266"
              stop-color="#221632"
        />
        <stop offset="0.826345"
              stop-color="#312652"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint24_radial_7585_10686"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(16.8929 7.79969) rotate(47.0825) scale(1.65402 2.91785)"
      >
        <stop offset="0.0771635"
              stop-color="#221632"
        />
        <stop offset="0.403697"
              stop-color="#312652"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint25_linear_7585_10686"
                      x1="20.9942"
                      y1="4.00977"
                      x2="20.9942"
                      y2="9.01654"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5D235A" />
        <stop offset="1"
              stop-color="#222058"
        />
      </linearGradient>
      <linearGradient id="paint26_linear_7585_10686"
                      x1="20.9951"
                      y1="5.74904"
                      x2="20.9951"
                      y2="7.24725"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.128532"
              stop-color="#452259"
              stop-opacity="0"
        />
        <stop offset="0.52515"
              stop-color="#FFFFFF"
              stop-opacity="0.1"
        />
        <stop offset="1"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint27_linear_7585_10686"
                      x1="18.7819"
                      y1="5.6865"
                      x2="23.1382"
                      y2="5.69677"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0348136"
              stop-color="#0E0B10"
        />
        <stop offset="0.169658"
              stop-color="#4C2B60"
              stop-opacity="0.59"
        />
        <stop offset="0.790425"
              stop-color="#312245"
              stop-opacity="0"
        />
        <stop offset="0.974698"
              stop-color="#36245B"
        />
      </linearGradient>
      <linearGradient id="paint28_linear_7585_10686"
                      x1="20.9951"
                      y1="4.30526"
                      x2="20.9942"
                      y2="9.01654"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.404558"
              stop-color="#452258"
              stop-opacity="0"
        />
        <stop offset="1"
              stop-color="#08055B"
        />
      </linearGradient>
      <linearGradient id="paint29_linear_7585_10686"
                      x1="18.7819"
                      y1="5.6865"
                      x2="23.1382"
                      y2="5.69677"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0808964"
              stop-color="#3F2853"
              stop-opacity="0"
        />
        <stop offset="0.161424"
              stop-color="#FFFFFF"
              stop-opacity="0.13"
        />
        <stop offset="0.316154"
              stop-color="#48225A"
              stop-opacity="0"
        />
        <stop offset="0.729975"
              stop-color="#48225A"
              stop-opacity="0"
        />
        <stop offset="0.863759"
              stop-color="#FFFFFF"
              stop-opacity="0.13"
        />
        <stop offset="0.95034"
              stop-color="#46235A"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint30_radial_7585_10686"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.2495 4.28924) rotate(47.1211) scale(0.598823 1.55913)"
      >
        <stop offset="0.0929266"
              stop-color="#412345"
        />
        <stop offset="1"
              stop-color="#5B255B"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint31_radial_7585_10686"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(22.0667 4.4017) rotate(50.371) scale(0.698287 1.8181)"
      >
        <stop offset="0.0929266"
              stop-color="#412345"
        />
        <stop offset="1"
              stop-color="#5B255B"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint32_radial_7585_10686"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(22.2655 8.84971) rotate(30.6) scale(1.48903 1.41445)"
      >
        <stop offset="0.0929266"
              stop-color="#1A132D"
        />
        <stop offset="0.74792"
              stop-color="#312652"
              stop-opacity="0"
        />
      </radialGradient>
      <radialGradient id="paint33_radial_7585_10686"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(19.4505 8.82805) rotate(128.264) scale(0.872464 1.86083)"
      >
        <stop offset="0.0929266"
              stop-color="#1A132D"
        />
        <stop offset="0.74792"
              stop-color="#312652"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint34_linear_7585_10686"
                      x1="2.99512"
                      y1="24.0511"
                      x2="28.9951"
                      y2="24.0511"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A59CA9" />
        <stop offset="1"
              stop-color="#BFB4C5"
        />
      </linearGradient>
      <linearGradient id="paint35_linear_7585_10686"
                      x1="2.72398"
                      y1="20.5278"
                      x2="5.59564"
                      y2="20.5415"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6E616E" />
        <stop offset="0.296347"
              stop-color="#6E616E"
              stop-opacity="0"
        />
        <stop offset="0.632218"
              stop-color="#9E93A1"
              stop-opacity="0"
        />
        <stop offset="0.788421"
              stop-color="#5B535B"
        />
        <stop offset="0.88007"
              stop-color="#6E616E"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint36_radial_7585_10686"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(4.74332 17.0617) rotate(149.39) scale(2.7079 4.74972)"
      >
        <stop offset="0.276917"
              stop-color="#A298A6"
        />
        <stop offset="0.562762"
              stop-color="#A298A6"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint37_linear_7585_10686"
                      x1="5.12594"
                      y1="15.8948"
                      x2="5.12594"
                      y2="16.5354"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#6E616E" />
        <stop offset="1"
              stop-color="#6E616E"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint38_radial_7585_10686"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(-0.992935 11.6761) rotate(39.1304) scale(14.2611 19.0195)"
      >
        <stop stop-color="#887B8B" />
        <stop offset="1"
              stop-color="#887B8B"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint39_linear_7585_10686"
                      x1="29.0641"
                      y1="21.5505"
                      x2="28.2596"
                      y2="21.5505"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E0DCE2" />
        <stop offset="1"
              stop-color="#E0DCE2"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint40_linear_7585_10686"
                      x1="9.49662"
                      y1="28.0113"
                      x2="9.49512"
                      y2="17.7436"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#323870" />
        <stop offset="0.92529"
              stop-color="#5C275C"
        />
        <stop offset="0.985547"
              stop-color="#2A192E"
        />
      </linearGradient>
      <linearGradient id="paint41_linear_7585_10686"
                      x1="14.8025"
                      y1="18.7538"
                      x2="6.08465"
                      y2="18.7262"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0668338"
              stop-color="#443268"
              stop-opacity="0"
        />
        <stop offset="0.126919"
              stop-color="#F7EFFC"
              stop-opacity="0.03"
        />
        <stop offset="0.172078"
              stop-color="#483067"
              stop-opacity="0.26"
        />
        <stop offset="1"
              stop-color="#4A2F65"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint42_linear_7585_10686"
                      x1="9.49512"
                      y1="16.7988"
                      x2="9.49512"
                      y2="28.0098"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0843437"
              stop-color="#443268"
              stop-opacity="0"
        />
        <stop offset="0.116721"
              stop-color="#F7EFFC"
              stop-opacity="0.05"
        />
        <stop offset="0.169187"
              stop-color="#483067"
              stop-opacity="0.26"
        />
        <stop offset="1"
              stop-color="#4A2F65"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint43_linear_7585_10686"
                      x1="4.58721"
                      y1="20.2374"
                      x2="9.49512"
                      y2="20.2097"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0209928"
              stop-color="#140A1C"
        />
        <stop offset="0.252918"
              stop-color="#3A346B"
              stop-opacity="0"
        />
        <stop offset="0.648368"
              stop-color="#572A5F"
              stop-opacity="0"
        />
        <stop offset="1"
              stop-color="#542B61"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint44_linear_7585_10686"
                      x1="9.49512"
                      y1="28.3586"
                      x2="9.49512"
                      y2="26.4093"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.163805"
              stop-color="#282953"
        />
        <stop offset="0.430175"
              stop-color="#37376E"
              stop-opacity="0"
        />
      </linearGradient>
      <radialGradient id="paint45_radial_7585_10686"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(13.7745 18.1613) rotate(126.655) scale(1.08042 2.23444)"
      >
        <stop offset="0.373674"
              stop-color="#44224B"
              stop-opacity="0.61"
        />
        <stop offset="0.831086"
              stop-color="#572C5A"
              stop-opacity="0"
        />
      </radialGradient>
      <linearGradient id="paint46_linear_7585_10686"
                      x1="16.835"
                      y1="22.005"
                      x2="17.7391"
                      y2="22.005"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5DFFFF" />
        <stop offset="1"
              stop-color="#5DFFFF"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint47_linear_7585_10686"
                      x1="19.615"
                      y1="24.2326"
                      x2="19.615"
                      y2="23.3963"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5DFFFF" />
        <stop offset="1"
              stop-color="#5DFFFF"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint48_linear_7585_10686"
                      x1="22.0023"
                      y1="23.205"
                      x2="22.002"
                      y2="25.8386"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FAFAFA"
              stop-opacity="0"
        />
        <stop offset="0.161013"
              stop-color="#80FFFF"
              stop-opacity="0.2"
        />
        <stop offset="0.485489"
              stop-color="#80FFFF"
        />
      </linearGradient>
      <linearGradient id="paint49_linear_7585_10686"
                      x1="19.5473"
                      y1="22.2029"
                      x2="14.0799"
                      y2="22.1526"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.139675"
              stop-color="#51D3F8"
              stop-opacity="0"
        />
        <stop offset="0.397796"
              stop-color="#5CF2FE"
        />
      </linearGradient>
      <linearGradient id="paint50_linear_7585_10686"
                      x1="28.6899"
                      y1="21.3459"
                      x2="22.0721"
                      y2="21.3459"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.390645"
              stop-color="#1E8DDC"
              stop-opacity="0.87"
        />
        <stop offset="0.513892"
              stop-color="#41B8FB"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint51_linear_7585_10686"
                      x1="21.5001"
                      y1="19.2666"
                      x2="21.5001"
                      y2="21.4094"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.246812"
              stop-color="#168AEA"
        />
        <stop offset="0.613782"
              stop-color="#40ADF0"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint52_linear_7585_10686"
                      x1="6.63206"
                      y1="16.01"
                      x2="27.0071"
                      y2="16.01"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EF3D89" />
        <stop offset="1"
              stop-color="#FF3D51"
        />
      </linearGradient>
      <linearGradient id="paint53_linear_7585_10686"
                      x1="16.0001"
                      y1="16.5209"
                      x2="16.0001"
                      y2="10.9008"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0543229"
              stop-color="#B43A5F"
        />
        <stop offset="0.319327"
              stop-color="#FA3E5D"
              stop-opacity="0"
        />
        <stop offset="0.631688"
              stop-color="#FF3D51"
              stop-opacity="0"
        />
        <stop offset="0.977955"
              stop-color="#C53B65"
        />
      </linearGradient>
      <linearGradient id="paint54_linear_7585_10686"
                      x1="30.0051"
                      y1="14.583"
                      x2="28.6787"
                      y2="14.583"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF5766" />
        <stop offset="1"
              stop-color="#FF5766"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint55_linear_7585_10686"
                      x1="1.44696"
                      y1="14.5645"
                      x2="3.23488"
                      y2="14.5645"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.210064"
              stop-color="#7C274B"
              stop-opacity="0.87"
        />
        <stop offset="0.893484"
              stop-color="#EC3E88"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint56_linear_7585_10686"
                      x1="30.9158"
                      y1="14.5331"
                      x2="28.2138"
                      y2="14.5077"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.191511"
              stop-color="#BC3C4A"
        />
        <stop offset="0.599467"
              stop-color="#FF4C5D"
              stop-opacity="0.06"
        />
        <stop offset="0.807847"
              stop-color="#FF4054"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint57_linear_7585_10686"
                      x1="7.47733"
                      y1="18.9873"
                      x2="7.47733"
                      y2="26.9612"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4DC7FF" />
        <stop offset="1"
              stop-color="#62F1FF"
        />
      </linearGradient>
      <linearGradient id="paint58_linear_7585_10686"
                      x1="5.91513"
                      y1="22.9742"
                      x2="6.37612"
                      y2="22.9742"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5DFFFF" />
        <stop offset="1"
              stop-color="#5DFFFF"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint59_linear_7585_10686"
                      x1="6.84606"
                      y1="27.4038"
                      x2="6.84607"
                      y2="25.7409"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5DFFFF" />
        <stop offset="1"
              stop-color="#5DFFFF"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint60_linear_7585_10686"
                      x1="7.64549"
                      y1="25.3605"
                      x2="7.64163"
                      y2="30.5974"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FAFAFA"
              stop-opacity="0"
        />
        <stop offset="0.161013"
              stop-color="#80FFFF"
              stop-opacity="0.2"
        />
        <stop offset="0.485489"
              stop-color="#80FFFF"
        />
      </linearGradient>
      <linearGradient id="paint61_linear_7585_10686"
                      x1="6.82338"
                      y1="23.3677"
                      x2="4.9924"
                      y2="23.3649"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.139675"
              stop-color="#51D3F8"
              stop-opacity="0"
        />
        <stop offset="0.555333"
              stop-color="#5CF2FE"
        />
      </linearGradient>
      <linearGradient id="paint62_linear_7585_10686"
                      x1="10.0734"
                      y1="21.6916"
                      x2="7.66887"
                      y2="21.6637"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.460792"
              stop-color="#1E8DDC"
              stop-opacity="0.87"
        />
        <stop offset="0.751135"
              stop-color="#41B8FB"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint63_linear_7585_10686"
                      x1="7.47733"
                      y1="17.529"
                      x2="7.47729"
                      y2="21.79"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.367086"
              stop-color="#168AEA"
        />
        <stop offset="0.512997"
              stop-color="#40ADF0"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint64_linear_7585_10686"
                      x1="11.5125"
                      y1="18.9873"
                      x2="11.5125"
                      y2="26.9612"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4DC7FF" />
        <stop offset="1"
              stop-color="#62F1FF"
        />
      </linearGradient>
      <linearGradient id="paint65_linear_7585_10686"
                      x1="9.95029"
                      y1="22.9742"
                      x2="10.4113"
                      y2="22.9742"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5DFFFF" />
        <stop offset="1"
              stop-color="#5DFFFF"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint66_linear_7585_10686"
                      x1="10.8812"
                      y1="27.4038"
                      x2="10.8812"
                      y2="25.7409"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5DFFFF" />
        <stop offset="1"
              stop-color="#5DFFFF"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint67_linear_7585_10686"
                      x1="11.6806"
                      y1="25.3605"
                      x2="11.6768"
                      y2="30.5974"
                      gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FAFAFA"
              stop-opacity="0"
        />
        <stop offset="0.161013"
              stop-color="#80FFFF"
              stop-opacity="0.2"
        />
        <stop offset="0.485489"
              stop-color="#80FFFF"
        />
      </linearGradient>
      <linearGradient id="paint68_linear_7585_10686"
                      x1="10.8585"
                      y1="23.3677"
                      x2="9.02755"
                      y2="23.3649"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.139675"
              stop-color="#51D3F8"
              stop-opacity="0"
        />
        <stop offset="0.555333"
              stop-color="#5CF2FE"
        />
      </linearGradient>
      <linearGradient id="paint69_linear_7585_10686"
                      x1="14.1086"
                      y1="21.6916"
                      x2="11.704"
                      y2="21.6637"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.460792"
              stop-color="#1E8DDC"
              stop-opacity="0.87"
        />
        <stop offset="0.751135"
              stop-color="#41B8FB"
              stop-opacity="0"
        />
      </linearGradient>
      <linearGradient id="paint70_linear_7585_10686"
                      x1="11.5125"
                      y1="17.529"
                      x2="11.5124"
                      y2="21.79"
                      gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.367086"
              stop-color="#168AEA"
        />
        <stop offset="0.512997"
              stop-color="#40ADF0"
              stop-opacity="0"
        />
      </linearGradient>
      <clipPath id="clip0_7585_10686">
        <rect width="32"
              height="32"
              fill="#FFFFFF"
        />
      </clipPath>
    </defs>
  </svg>
</template>
